/* eslint-disable react/prop-types */
import React from "react";
import { CustomError } from "./CustomError";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // You can log errors to an external service here
    console.error("ErrorBoundary caught:", error, errorInfo);
    this.setState({ error });
  }

  render() {
    if (this.state.hasError) {
      return (
        <CustomError
          title="Something Went Wrong!"
          message="We're experiencing a temporary issue."
          subMessage="Please try again in a moment."
        />
      );
    }

    return this.props.children;
  }
}

export { ErrorBoundary };
